module.exports = __webpack_public_path__ + "static/akanmu-7a24e1943b7ae91ff4116dca64c939c3.png";